(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-cart-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  const form = document.getElementById('lunae-cartpage-form');
  if (!form) return;

  function fmt(cents) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }

  async function changeLine(key, quantity, btn) {
    if (btn) btn.disabled = true;
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await r.json();
      if (quantity === 0) {
        // Reload page when item removed (to refresh whole list cleanly)
        window.location.reload();
        return;
      }
      // Update individual line + totals
      const li = form.querySelector('[data-key="' + key + '"]');
      if (li) {
        const item = cart.items.find(i => i.key === key);
        if (item) {
          const priceEl = li.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = fmt(item.final_line_price);
          const input = li.querySelector('[data-qty-input]');
          if (input) input.value = item.quantity;
        }
      }
      // Update totals
      const sub = form.querySelector('[data-subtotal]');
      const tot = form.querySelector('[data-total]');
      if (sub) sub.textContent = fmt(cart.items_subtotal_price);
      if (tot) tot.textContent = fmt(cart.total_price);
      // Update header cart count
      document.querySelectorAll('.lunae-header__shop-label').forEach(el => {
        el.textContent = cart.item_count > 0 ? ('Mandje · ' + cart.item_count) : 'Mandje';
      });
      document.querySelectorAll('.lunae-header__shop-count').forEach(el => {
        if (cart.item_count > 0) { el.textContent = cart.item_count; el.style.display = ''; }
        else el.style.display = 'none';
      });
    } catch (e) { console.warn('cart update failed', e); }
    finally { if (btn) btn.disabled = false; }
  }

  // qty + / - buttons
  form.querySelectorAll('[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      const li = btn.closest('.lunae-cartpage__item');
      if (!li) return;
      const input = li.querySelector('[data-qty-input]');
      const cur = parseInt(input.value || '1', 10);
      const next = btn.dataset.act === 'inc' ? cur + 1 : Math.max(0, cur - 1);
      input.value = next;
      changeLine(li.dataset.key, next, btn);
    });
  });

  // Manual qty input change
  form.querySelectorAll('[data-qty-input]').forEach(input => {
    let t;
    input.addEventListener('change', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const li = input.closest('.lunae-cartpage__item');
        const n = Math.max(0, parseInt(input.value || '0', 10));
        input.value = n;
        changeLine(li.dataset.key, n, null);
      }, 300);
    });
  });

  // Remove button
  form.querySelectorAll('.lunae-cartpage__remove').forEach(btn => {
    btn.addEventListener('click', () => changeLine(btn.dataset.key, 0, btn));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  const header = document.querySelector('.lunae-header');
  let scheduled = false;
  function syncHeader() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 48); scheduled = false; }
  syncHeader();
  window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(syncHeader); } }, { passive: true });
  window.addEventListener('pageshow', syncHeader);
  const benefits = document.querySelector('.lunae-announcement');
  if (benefits) {
    const items = [...benefits.querySelectorAll('.lunae-announcement__items a')];
    let index = 0, paused = matchMedia('(prefers-reduced-motion:reduce)').matches;
    function syncItems(){items.forEach((item,i)=>{item.setAttribute('aria-hidden',String(i!==index));item.tabIndex=i===index?0:-1;});}
    function advance(){const old=items[index];old.classList.remove('is-current');old.classList.add('is-exit');index=(index+1)%items.length;items[index].classList.add('is-current');syncItems();setTimeout(()=>old.classList.remove('is-exit'),650);}
    syncItems();
    setInterval(()=>{if(!paused&&!document.hidden&&!benefits.matches(':hover')&&!benefits.contains(document.activeElement))advance();},3800);
  }
  // Visual category panels share hover, click and keyboard state.
  const navItems = [...header.querySelectorAll('[data-ln-nav-item]')];
  const desktopMenu = matchMedia('(min-width:1101px)');
  let activeItem = null, enterTimer, leaveTimer;
  function closeVisualMenu(restoreFocus = false) {
    clearTimeout(enterTimer); clearTimeout(leaveTimer);
    if (!activeItem) return;
    const previous = activeItem;
    activeItem = null;
    previous.removeAttribute('data-open');
    previous.querySelector('[data-ln-panel]').inert = true;
    previous.querySelector('[data-ln-panel]').setAttribute('aria-hidden', 'true');
    previous.querySelector('.ln-nav-toggle').setAttribute('aria-expanded', 'false');
    header.classList.remove('has-visual-menu');
    if (restoreFocus) previous.querySelector('.ln-nav-toggle').focus();
  }
  function openVisualMenu(item) {
    clearTimeout(enterTimer); clearTimeout(leaveTimer);
    if (!desktopMenu.matches || activeItem === item) return;
    closeVisualMenu();
    activeItem = item;
    item.setAttribute('data-open', '');
    item.querySelector('[data-ln-panel]').inert = false;
    item.querySelector('[data-ln-panel]').setAttribute('aria-hidden', 'false');
    item.querySelector('.ln-nav-toggle').setAttribute('aria-expanded', 'true');
    header.classList.add('has-visual-menu');
  }
  navItems.forEach(item => {
    const toggle = item.querySelector('.ln-nav-toggle');
    item.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(leaveTimer); clearTimeout(enterTimer);
      enterTimer = setTimeout(() => openVisualMenu(item), 100);
    });
    item.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(enterTimer);
      leaveTimer = setTimeout(() => {
        if (activeItem === item && !item.contains(document.activeElement)) closeVisualMenu();
      }, 180);
    });
    toggle.addEventListener('click', () => activeItem === item ? closeVisualMenu() : openVisualMenu(item));
    item.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); closeVisualMenu(true); }
      if (event.key === 'ArrowDown' && event.target.closest('.ln-nav-label')) {
        event.preventDefault(); openVisualMenu(item);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (activeItem === item) item.querySelector('[data-ln-panel] a').focus();
        }));
      }
    });
    item.addEventListener('focusout', () => setTimeout(() => {
      if (activeItem === item && !item.contains(document.activeElement)) closeVisualMenu();
    }, 0));
  });
  document.addEventListener('pointerdown', event => {
    if (activeItem && !activeItem.contains(event.target)) closeVisualMenu();
  });
  header.querySelector('.ln-menu-backdrop').addEventListener('click', () => closeVisualMenu());
  desktopMenu.addEventListener('change', () => closeVisualMenu());
  window.addEventListener('pageshow', () => closeVisualMenu());
  const drawer = document.getElementById('lunae-drawer');
  if (!drawer) return;
  const opens = document.querySelectorAll('[data-lunae-menu-open]');
  const closes = document.querySelectorAll('[data-lunae-menu-close]');
  const hamb = document.querySelector('.lunae-hamburger');

  function open() {
    drawer.inert = false;
    drawer.classList.add('is-open');
    setTimeout(() => drawer.querySelector('button[data-lunae-menu-close]').focus(), 30);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lunae-no-scroll');
    if (hamb) {
      hamb.classList.add('is-open');
      hamb.setAttribute('aria-expanded', 'true');
      hamb.setAttribute('aria-label', 'Menu sluiten');
    }
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.inert = true;
    if (hamb) hamb.focus();
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lunae-no-scroll');
    if (hamb) {
      hamb.classList.remove('is-open');
      hamb.setAttribute('aria-expanded', 'false');
      hamb.setAttribute('aria-label', 'Menu openen');
    }
  }
  opens.forEach(b => b.addEventListener('click', open));
  closes.forEach(b => b.addEventListener('click', close));
  // Keep keyboard focus inside the open drawer.
  drawer.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const list = [...drawer.querySelectorAll('a[href], button:not([disabled]), summary')].filter(el => el.getClientRects().length);
    const first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // Sluit op Escape
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  // Sluit als je op een drawer link tikt (navigatie volgt sowieso)
  drawer.querySelectorAll('a[href]:not([href^="#"])').forEach(a => a.addEventListener('click', () => setTimeout(close, 50)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init() {
    const root = document.querySelector('.ln-home');
    if (!root || root.dataset.revealInit || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.dataset.revealInit = 'true';
    const items = root.querySelectorAll('.ln-home-heading,.ln-home-category,.ln-home-story__copy,.ln-home-product,.ln-home-outside__copy,.ln-home-help__grid>div');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -24px 0px' });
    items.forEach((item,index) => {
      item.classList.add('ln-reveal');
      if (item.matches('.ln-home-category,.ln-home-product')) item.style.setProperty('--ln-delay', (index % 3) * 80 + 'ms');
      observer.observe(item);
    });
    root.classList.add('ln-home-reveal-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
(function(){
  function initFaq(){
    document.querySelectorAll('.ln-home-faq details').forEach(details=>{
      if(details.dataset.motionReady)return;
      const summary=details.querySelector('summary'),content=details.querySelector('.ln-home-faq__content');
      if(!summary||!content)return;
      details.dataset.motionReady='true';
      let animation=null,expanded=details.open;
      summary.setAttribute('aria-expanded',String(expanded));
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      summary.addEventListener('click',event=>{
        event.preventDefault();
        const from=details.open?content.getBoundingClientRect().height:0,opacity=getComputedStyle(content).opacity;
        if(animation){animation.cancel();animation=null;}
        expanded=!expanded;
        details.dataset.expanded=String(expanded);
        summary.setAttribute('aria-expanded',String(expanded));
        content.inert=!expanded;
        if(motion.matches||!content.animate){details.open=expanded;content.style.overflow='';return;}
        details.open=true;
        content.style.overflow='hidden';
        const target=expanded?content.scrollHeight:0;
        const current=content.animate([{height:from+'px',opacity:from?opacity:0},{height:target+'px',opacity:expanded?1:0}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
        animation=current;
        current.onfinish=()=>{if(animation!==current)return;details.open=expanded;content.style.overflow='';animation=null;};
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFaq);else initFaq();
  document.addEventListener('shopify:section:load',initFaq);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-pdp-flessenwarmer"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ----- Dynamic shipping message (NL timezone, weekends + holidays) -----
  // Fulfillment center werkt Ma-Vr (geen weekend, geen Nederlandse feestdagen).
  // PostNL bezorgt Ma-Za (geen zondag, geen feestdagen).
  const NL_HOLIDAYS = new Set([
    // 2026
    '2026-01-01','2026-04-03','2026-04-05','2026-04-06',
    '2026-04-27','2026-05-14','2026-05-24','2026-05-25',
    '2026-12-25','2026-12-26',
    // 2027
    '2027-01-01','2027-03-26','2027-03-28','2027-03-29',
    '2027-04-27','2027-05-06','2027-05-16','2027-05-17',
    '2027-12-25','2027-12-26',
    // 2028
    '2028-01-01','2028-04-14','2028-04-16','2028-04-17',
    '2028-04-27','2028-05-25','2028-06-04','2028-06-05',
    '2028-12-25','2028-12-26'
  ]);
  const DAY_NAMES = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  const CUTOFF_HOUR = 22;

  function nlNow() {
    // Forceer Europe/Amsterdam ongeacht user-timezone
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }
  function ymd(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  function isFulfillDay(d) {
    const dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function isDeliveryDay(d) {
    if (d.getDay() === 0) return false; // zondag bezorgt PostNL niet
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function addDays(d, n) {
    const nd = new Date(d);
    nd.setDate(nd.getDate() + n);
    return nd;
  }
  function computeShipping() {
    const now = nlNow();
    let ship;
    if (isFulfillDay(now) && now.getHours() < CUTOFF_HOUR) {
      ship = now;
    } else {
      ship = addDays(now, 1);
      while (!isFulfillDay(ship)) ship = addDays(ship, 1);
    }
    let delivery = addDays(ship, 1);
    while (!isDeliveryDay(delivery)) delivery = addDays(delivery, 1);

    const tomorrow = addDays(now, 1);
    const dayLabel = (ymd(delivery) === ymd(tomorrow))
      ? 'morgen'
      : DAY_NAMES[delivery.getDay()];
    return dayLabel;
  }
  const dayLabel = computeShipping();
  document.querySelectorAll('[data-lunae-ship-short]').forEach(el => {
    el.textContent = 'Voor ' + CUTOFF_HOUR + ':00 → ' + dayLabel + ' in huis';
  });
  document.querySelectorAll('[data-lunae-ship-long]').forEach(el => {
    el.textContent = 'voor ' + CUTOFF_HOUR + ':00 besteld, ' + dayLabel + ' in huis';
  });

  // Gallery: swipe / thumb / pager — werkt zowel desktop (fade) als mobile (scroll-snap)
  const swiper = document.getElementById('lunae-swiper');
  const slides = swiper ? swiper.querySelectorAll('.lunae-gallery__slide') : [];
  const thumbs = document.querySelectorAll('.lunae-gallery__thumb[data-i]');
  const pager  = document.getElementById('lunae-pager');
  const total  = slides.length;
  function isMobileGallery() { return matchMedia('(max-width: 1080px)').matches; }
  function setActive(i) {
    if (i < 0 || i >= total) return;
    slides.forEach((s, j) => s.classList.toggle('is-active', i === j));
    thumbs.forEach((t, j) => {
      t.classList.toggle('is-active', i === j);
      t.setAttribute('aria-selected', i === j ? 'true' : 'false');
    });
    if (pager) pager.textContent = (i + 1) + ' / ' + total;
    // Move only the thumbnail strip; keep the page itself in place.
    const activeThumb = thumbs[i];
    const rail = activeThumb && activeThumb.parentElement;
    if (rail) {
      const r = rail.getBoundingClientRect();
      const t = activeThumb.getBoundingClientRect();
      if (isMobileGallery()) {
        if (t.left < r.left || t.right > r.right)
          rail.scrollTo({ left: rail.scrollLeft + t.left - r.left - (rail.clientWidth - t.width) / 2, behavior: 'smooth' });
      } else if (t.top < r.top || t.bottom > r.bottom) {
        rail.scrollTo({ top: rail.scrollTop + t.top - r.top - (rail.clientHeight - t.height) / 2, behavior: 'smooth' });
      }
    }
  }
  thumbs.forEach((t) => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const idx = parseInt(t.getAttribute('data-i') || '0', 10);
      if (isMobileGallery() && swiper && slides[idx]) {
        // Smooth scroll naar de juiste slide
        slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActive(idx);
        // Scroll de thumb zelf ook in beeld
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        setActive(idx);
      }
    });
  });
  // Listen op scroll van swiper → update active thumb + pager
  let scrollT;
  if (swiper) {
    swiper.addEventListener('scroll', () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        if (!isMobileGallery()) return;
        const idx = Math.round(swiper.scrollLeft / swiper.clientWidth);
        setActive(idx);
        updateArrowState(idx);
      }, 60);
    }, { passive: true });
  }

  // ----- Prev/Next arrows -----
  const arrowPrev = document.getElementById('lunae-arrow-prev');
  const arrowNext = document.getElementById('lunae-arrow-next');
  function currentIndex() {
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }
  function updateArrowState(i) {
    if (!arrowPrev || !arrowNext) return;
    // Loop-style navigation: nooit disablen (volgende: terug naar 0, vorige: laatste)
    arrowPrev.disabled = false;
    arrowNext.disabled = false;
  }
  function goTo(i) {
    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    if (isMobileGallery() && swiper && slides[i]) {
      slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActive(i);
      const thumb = document.querySelector('.lunae-gallery__thumb[data-i="' + i + '"]');
      if (thumb) thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      setActive(i);
    }
    updateArrowState(i);
  }
  if (arrowPrev) arrowPrev.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() - 1); });
  if (arrowNext) arrowNext.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() + 1); });
  // Keyboard support: ← / → wanneer gallery in focus
  const galRoot = document.querySelector('.lunae-gallery__main');
  if (galRoot && total > 1) {
    galRoot.setAttribute('tabindex', '0');
    galRoot.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
    });
  }

  // Qty controls
  document.querySelectorAll('.lunae-qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        let v = parseInt(input.value || 1);
        if (b.dataset.act === 'dec') v = Math.max(1, v - 1);
        if (b.dataset.act === 'inc') v = Math.min(9, v + 1);
        input.value = v;
      });
    });
  });

  // FAQ single-open
  document.querySelectorAll('.lunae-faq details').forEach(d => {
    d.addEventListener('toggle', () => {
      if (d.open) document.querySelectorAll('.lunae-faq details').forEach(o => { if (o !== d) o.open = false; });
    });
  });

  // Sticky buy bar
  const sticky = document.getElementById('lunae-sticky-buy');
  const atc    = document.getElementById('lunae-atc');
  const onScroll = () => {
    if (!atc || !sticky) return;
    const r = atc.getBoundingClientRect();
    if (r.bottom < 0) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-pdp-verduistering"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ----- Dynamic shipping message (NL timezone, weekends + holidays) -----
  const NL_HOLIDAYS = new Set([
    '2026-01-01','2026-04-03','2026-04-05','2026-04-06',
    '2026-04-27','2026-05-14','2026-05-24','2026-05-25',
    '2026-12-25','2026-12-26',
    '2027-01-01','2027-03-26','2027-03-28','2027-03-29',
    '2027-04-27','2027-05-06','2027-05-16','2027-05-17',
    '2027-12-25','2027-12-26',
    '2028-01-01','2028-04-14','2028-04-16','2028-04-17',
    '2028-04-27','2028-05-25','2028-06-04','2028-06-05',
    '2028-12-25','2028-12-26'
  ]);
  const DAY_NAMES = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  const CUTOFF_HOUR = 22;

  function nlNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }
  function ymd(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  function isFulfillDay(d) {
    const dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function isDeliveryDay(d) {
    if (d.getDay() === 0) return false;
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function addDays(d, n) {
    const nd = new Date(d);
    nd.setDate(nd.getDate() + n);
    return nd;
  }
  function computeShipping() {
    const now = nlNow();
    let ship;
    if (isFulfillDay(now) && now.getHours() < CUTOFF_HOUR) {
      ship = now;
    } else {
      ship = addDays(now, 1);
      while (!isFulfillDay(ship)) ship = addDays(ship, 1);
    }
    let delivery = addDays(ship, 1);
    while (!isDeliveryDay(delivery)) delivery = addDays(delivery, 1);
    const tomorrow = addDays(now, 1);
    return (ymd(delivery) === ymd(tomorrow)) ? 'morgen' : DAY_NAMES[delivery.getDay()];
  }
  const dayLabel = computeShipping();
  document.querySelectorAll('[data-lunae-ship-long]').forEach(el => {
    el.textContent = 'voor ' + CUTOFF_HOUR + ':00 besteld, ' + dayLabel + ' in huis';
  });

  // ----- Gallery -----
  const swiper = document.getElementById('lunae-swiper');
  const slides = swiper ? swiper.querySelectorAll('.lunae-gallery__slide') : [];
  const thumbs = document.querySelectorAll('.lunae-gallery__thumb[data-i]');
  const pager  = document.getElementById('lunae-pager');
  const total  = slides.length;
  function isMobileGallery() { return matchMedia('(max-width: 1080px)').matches; }
  function setActive(i) {
    if (i < 0 || i >= total) return;
    slides.forEach((s, j) => s.classList.toggle('is-active', i === j));
    thumbs.forEach((t, j) => {
      t.classList.toggle('is-active', i === j);
      t.setAttribute('aria-selected', i === j ? 'true' : 'false');
    });
    if (pager) pager.textContent = (i + 1) + ' / ' + total;
    // Move only the thumbnail strip; keep the page itself in place.
    const activeThumb = thumbs[i];
    const rail = activeThumb && activeThumb.parentElement;
    if (rail) {
      const r = rail.getBoundingClientRect();
      const t = activeThumb.getBoundingClientRect();
      if (isMobileGallery()) {
        if (t.left < r.left || t.right > r.right)
          rail.scrollTo({ left: rail.scrollLeft + t.left - r.left - (rail.clientWidth - t.width) / 2, behavior: 'smooth' });
      } else if (t.top < r.top || t.bottom > r.bottom) {
        rail.scrollTo({ top: rail.scrollTop + t.top - r.top - (rail.clientHeight - t.height) / 2, behavior: 'smooth' });
      }
    }
  }
  thumbs.forEach((t) => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const idx = parseInt(t.getAttribute('data-i') || '0', 10);
      if (isMobileGallery() && swiper && slides[idx]) {
        slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActive(idx);
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        setActive(idx);
      }
    });
  });
  let scrollT;
  if (swiper) {
    swiper.addEventListener('scroll', () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        if (!isMobileGallery()) return;
        const idx = Math.round(swiper.scrollLeft / swiper.clientWidth);
        setActive(idx);
      }, 60);
    }, { passive: true });
  }

  // ----- Prev/Next arrows -----
  const arrowPrev = document.getElementById('lunae-arrow-prev');
  const arrowNext = document.getElementById('lunae-arrow-next');
  function currentIndex() {
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }
  function goTo(i) {
    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    if (isMobileGallery() && swiper && slides[i]) {
      slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActive(i);
      const thumb = document.querySelector('.lunae-gallery__thumb[data-i="' + i + '"]');
      if (thumb) thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      setActive(i);
    }
  }
  if (arrowPrev) arrowPrev.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() - 1); });
  if (arrowNext) arrowNext.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() + 1); });
  const galRoot = document.querySelector('.lunae-gallery__main');
  if (galRoot && total > 1) {
    galRoot.setAttribute('tabindex', '0');
    galRoot.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
    });
  }

  // ----- Qty controls -----
  document.querySelectorAll('.lunae-qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        let v = parseInt(input.value || 1);
        if (b.dataset.act === 'dec') v = Math.max(1, v - 1);
        if (b.dataset.act === 'inc') v = Math.min(9, v + 1);
        input.value = v;
      });
    });
  });

  // ----- Sticky buy bar (show on scroll past ATC) -----
  const sticky = document.getElementById('lunae-sticky-buy');
  const atc    = document.getElementById('lunae-atc');
  const onScroll = () => {
    if (!atc || !sticky) return;
    const r = atc.getBoundingClientRect();
    if (r.bottom < 0) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunae-pdp-whitenoise"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Animate only the redesigned specification disclosures; native details is the fallback.
  function initLunaeSpecMotion(root) {
    root.querySelectorAll('.ln-refresh .ln-spec-group').forEach(details => {
      if (details.dataset.lnMotionReady || typeof details.animate !== 'function') return;
      const summary = details.querySelector('summary');
      if (!summary) return;
      details.dataset.lnMotionReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animation = null;
      let expanded = details.open;

      function settle() {
        const previous = animation;
        animation = null;
        if (previous) {
          previous.onfinish = null;
          previous.cancel();
        }
        details.open = expanded;
        details.dataset.lnExpanded = String(expanded);
        details.style.removeProperty('height');
        details.style.removeProperty('overflow');
      }

      summary.addEventListener('click', event => {
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Capture the in-flight height before cancelling, so rapid clicks reverse smoothly.
        const startHeight = details.getBoundingClientRect().height;
        if (!animation) expanded = details.open;
        expanded = !expanded;
        if (animation) {
          animation.onfinish = null;
          animation.cancel();
          animation = null;
        }
        details.dataset.lnExpanded = String(expanded);
        if (reducedMotion.matches) {
          settle();
          return;
        }
        details.open = true;
        details.style.height = 'auto';
        const style = getComputedStyle(details);
        const closedHeight = summary.getBoundingClientRect().height +
          parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const endHeight = expanded ? details.getBoundingClientRect().height : closedHeight;
        details.style.height = startHeight + 'px';
        details.style.overflow = 'hidden';
        animation = details.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' }
        );
        animation.onfinish = settle;
      });
      // Keep natural heights after resizing and respect motion preferences immediately.
      window.addEventListener('resize', () => { if (animation) settle(); });
      reducedMotion.addEventListener('change', () => { if (animation) settle(); });
    });
  }
  initLunaeSpecMotion(document);
  document.addEventListener('shopify:section:load', event => initLunaeSpecMotion(event.target));

  // ----- Dynamic shipping message (NL timezone, weekends + holidays) -----
  // Fulfillment center werkt Ma-Vr (geen weekend, geen Nederlandse feestdagen).
  // PostNL bezorgt Ma-Za (geen zondag, geen feestdagen).
  const NL_HOLIDAYS = new Set([
    // 2026
    '2026-01-01','2026-04-03','2026-04-05','2026-04-06',
    '2026-04-27','2026-05-14','2026-05-24','2026-05-25',
    '2026-12-25','2026-12-26',
    // 2027
    '2027-01-01','2027-03-26','2027-03-28','2027-03-29',
    '2027-04-27','2027-05-06','2027-05-16','2027-05-17',
    '2027-12-25','2027-12-26',
    // 2028
    '2028-01-01','2028-04-14','2028-04-16','2028-04-17',
    '2028-04-27','2028-05-25','2028-06-04','2028-06-05',
    '2028-12-25','2028-12-26'
  ]);
  const DAY_NAMES = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  const CUTOFF_HOUR = 22;

  function nlNow() {
    // Forceer Europe/Amsterdam ongeacht user-timezone
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }
  function ymd(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  function isFulfillDay(d) {
    const dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function isDeliveryDay(d) {
    if (d.getDay() === 0) return false; // zondag bezorgt PostNL niet
    return !NL_HOLIDAYS.has(ymd(d));
  }
  function addDays(d, n) {
    const nd = new Date(d);
    nd.setDate(nd.getDate() + n);
    return nd;
  }
  function computeShipping() {
    const now = nlNow();
    let ship;
    if (isFulfillDay(now) && now.getHours() < CUTOFF_HOUR) {
      ship = now;
    } else {
      ship = addDays(now, 1);
      while (!isFulfillDay(ship)) ship = addDays(ship, 1);
    }
    let delivery = addDays(ship, 1);
    while (!isDeliveryDay(delivery)) delivery = addDays(delivery, 1);

    const tomorrow = addDays(now, 1);
    const dayLabel = (ymd(delivery) === ymd(tomorrow))
      ? 'morgen'
      : DAY_NAMES[delivery.getDay()];
    return dayLabel;
  }
  const dayLabel = computeShipping();
  document.querySelectorAll('[data-lunae-ship-short]').forEach(el => {
    el.textContent = 'Voor ' + CUTOFF_HOUR + ':00 → ' + dayLabel + ' in huis';
  });
  document.querySelectorAll('[data-lunae-ship-long]').forEach(el => {
    el.textContent = 'voor ' + CUTOFF_HOUR + ':00 besteld, ' + dayLabel + ' in huis';
  });

  // Gallery: swipe / thumb / pager — werkt zowel desktop (fade) als mobile (scroll-snap)
  const swiper = document.getElementById('lunae-swiper');
  const slides = swiper ? swiper.querySelectorAll('.lunae-gallery__slide') : [];
  const thumbs = document.querySelectorAll('.lunae-gallery__thumb[data-i]');
  const pager  = document.getElementById('lunae-pager');
  const total  = slides.length;
  function isMobileGallery() { return matchMedia('(max-width: 1080px)').matches; }
  function setActive(i) {
    if (i < 0 || i >= total) return;
    slides.forEach((s, j) => s.classList.toggle('is-active', i === j));
    thumbs.forEach((t, j) => {
      t.classList.toggle('is-active', i === j);
      t.setAttribute('aria-selected', i === j ? 'true' : 'false');
    });
    if (pager) pager.textContent = (i + 1) + ' / ' + total;
    // Move only the thumbnail strip; keep the page itself in place.
    const activeThumb = thumbs[i];
    const rail = activeThumb && activeThumb.parentElement;
    if (rail) {
      const r = rail.getBoundingClientRect();
      const t = activeThumb.getBoundingClientRect();
      if (isMobileGallery()) {
        if (t.left < r.left || t.right > r.right)
          rail.scrollTo({ left: rail.scrollLeft + t.left - r.left - (rail.clientWidth - t.width) / 2, behavior: 'smooth' });
      } else if (t.top < r.top || t.bottom > r.bottom) {
        rail.scrollTo({ top: rail.scrollTop + t.top - r.top - (rail.clientHeight - t.height) / 2, behavior: 'smooth' });
      }
    }
  }
  thumbs.forEach((t) => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const idx = parseInt(t.getAttribute('data-i') || '0', 10);
      if (isMobileGallery() && swiper && slides[idx]) {
        // Smooth scroll naar de juiste slide
        slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActive(idx);
        // Scroll de thumb zelf ook in beeld
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        setActive(idx);
      }
    });
  });
  // Listen op scroll van swiper → update active thumb + pager
  let scrollT;
  if (swiper) {
    swiper.addEventListener('scroll', () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        if (!isMobileGallery()) return;
        const idx = Math.round(swiper.scrollLeft / swiper.clientWidth);
        setActive(idx);
        updateArrowState(idx);
      }, 60);
    }, { passive: true });
  }

  // ----- Prev/Next arrows -----
  const arrowPrev = document.getElementById('lunae-arrow-prev');
  const arrowNext = document.getElementById('lunae-arrow-next');
  function currentIndex() {
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }
  function updateArrowState(i) {
    if (!arrowPrev || !arrowNext) return;
    // Loop-style navigation: nooit disablen (volgende: terug naar 0, vorige: laatste)
    arrowPrev.disabled = false;
    arrowNext.disabled = false;
  }
  function goTo(i) {
    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    if (isMobileGallery() && swiper && slides[i]) {
      slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActive(i);
      const thumb = document.querySelector('.lunae-gallery__thumb[data-i="' + i + '"]');
      if (thumb) thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      setActive(i);
    }
    updateArrowState(i);
  }
  if (arrowPrev) arrowPrev.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() - 1); });
  if (arrowNext) arrowNext.addEventListener('click', (e) => { e.preventDefault(); goTo(currentIndex() + 1); });
  // Keyboard support: ← / → wanneer gallery in focus
  const galRoot = document.querySelector('.lunae-gallery__main');
  if (galRoot && total > 1) {
    galRoot.setAttribute('tabindex', '0');
    galRoot.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
    });
  }

  // Qty controls
  document.querySelectorAll('.lunae-qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        let v = parseInt(input.value || 1);
        if (b.dataset.act === 'dec') v = Math.max(1, v - 1);
        if (b.dataset.act === 'inc') v = Math.min(9, v + 1);
        input.value = v;
      });
    });
  });

  // FAQ single-open
  document.querySelectorAll('.lunae-faq details').forEach(d => {
    d.addEventListener('toggle', () => {
      if (d.open) document.querySelectorAll('.lunae-faq details').forEach(o => { if (o !== d) o.open = false; });
    });
  });

  // Sticky buy bar
  const sticky = document.getElementById('lunae-sticky-buy');
  const atc    = document.getElementById('lunae-atc');
  const onScroll = () => {
    if (!atc || !sticky) return;
    const r = atc.getBoundingClientRect();
    if (r.bottom < 0) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
